import React from 'react';
import PropTypes from 'prop-types';

const AppContext = React.createContext();

AppContext.propTypes = {
    embedded: PropTypes.object,
    i18next: PropTypes.object,
    phoneEnabled: PropTypes.bool,
};

export default AppContext;
